module.exports = __webpack_public_path__ + "img/zhangye.5e8c7503.jpg";